import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminContext, ServiceOrderContext, UserContext } from '../../../App';
import OrderHeader from '../OrderHeader/OrderHeader';
import Payment from '../Payment/Payment';

const Order = () => {
    const [order, setOrder] = useState([])
    const [loggedInUser, setLoggedInUser] = useContext(UserContext)
    const [serviceOrder, setServiceOrder] = useContext(ServiceOrderContext)
    useEffect(() => {
            fetch('https://assignment-11-samiun.herokuapp.com/order?email=' + loggedInUser.email)
            .then(res => res.json())
            .then(data => setOrder(data[data.length - 1]))
    }, [loggedInUser.email])
    const handleSubmit = (e) => {
        e.preventDefault();
    }
    const {title, description, img, price,} = serviceOrder
    const {email, displayName} = loggedInUser
    const handleClick = () => {
        const state = "pending"
        const order = {title, img, description, price, email, displayName, state}
        fetch('https://assignment-11-samiun.herokuapp.com/addOrder', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(order)
        })
        .then(res => res.json())
        .then(data => console.log(data))
    }
    return (
        <div className="row">
            <div className="col-md-2">
                <OrderHeader/>
            </div>
            <div className="col-md-10 mt-4">
                <div className="d-flex justify-content-between">
                <h3 className="mb-2">Order</h3>
                <h4>{loggedInUser.displayName}</h4>
                </div>
                <div className="mt-3 ps-5 pt-5" style={{background: '#F4F7FC', height: '100vh'}}>
                <form onSubmit={handleSubmit}>
                    <input type="text" class="form-control mb-4" placeholder="name" style={{width: '500px', border: 'none'}} required/>
                    <input type="email" class="form-control mb-4" placeholder="email" style={{width: '500px', border: 'none'}} />
                    <input type="text" class="form-control" placeholder="order" style={{width: '500px', border: 'none'}} />
                <Payment />
                <Link to="/orderlist" style={{textDecoration: 'none'}}><button type="submit" className="btn-style mt-4" style={{width: '500px'}} onClick={handleClick}>Pay</button></Link>
                </form>
                </div>
            </div>
        </div>
    );
};

export default Order;